import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import adminWhiteLabelApi from "../../api/admin/AdminWhiteLabel";
import {
  WhiteLabelRequestDTO,
  WhiteLabelResponseDTO,
} from "../../../types/adminWhiteLabel";

const initialState = {
  whiteLabelState: {} as WhiteLabelResponseDTO,
};

export const trunkGetWhiteLabel = createAsyncThunk(
  "wapi/admins/config/whitelabel/get",
  async () => {
    const resp = await adminWhiteLabelApi.getWhiteLabel();
    return resp;
  }
);
export const trunkSetWhiteLabel = createAsyncThunk(
  "wapi/admins/config/whitelabel/set",
  async (request: WhiteLabelRequestDTO) => {
    const resp = await adminWhiteLabelApi.setWhiteLabel(request);
    return resp;
  }
);

export const trunkResetWhiteLabel = createAsyncThunk(
  "wapi/admins/config/whitelabel/reset",
  async () => {
    const resp = await adminWhiteLabelApi.resetWhiteLabel();
    return resp;
  }
);

const adminWhiteLabelSlice = createSlice({
  name: "adminWhiteLabel",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      trunkGetWhiteLabel.fulfilled,
      (state, { payload: whiteLabelData }) => {
        state.whiteLabelState = whiteLabelData;
      }
    );
    builder.addCase(
      trunkSetWhiteLabel.fulfilled,
      (state, { payload: whiteLabelData }) => {
        state.whiteLabelState = whiteLabelData;
      }
    );
  },
});

export const adminWhiteLabelActions = adminWhiteLabelSlice.actions;
export default adminWhiteLabelSlice.reducer;
